import { Divider } from 'ant-design-vue';
import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createFieldRadioGroup } from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createField1 as createFieldInformProduct } from "../../../inform/request/inform-product/inform-product.logic";
import { setProduct } from "./hc-info.section";

const InformProductQtyList = defineAsyncComponent(() => import("../../../inform/request/inform-product/InformProductQtyList"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hcProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createField = ({ props, data, key, items, initItems, isLoading }) => {
    const { viewOnly, menuContext, informKey, request, viewOnlyInspection } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : "";
    const modelInform = lodash.get(modelRef, informKey);
    const initModelInform = lodash.get(initialModel, informKey);
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isHc`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hcProduct.isHc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.isHc ? model : null,
                            "onUpdate:value": () => {
                                items.forEach(item => {
                                    item.isHc = false;
                                    item.isSave = true;
                                });
                                model.isHc = true;
                                modelRef.refHcTemp.tradeNameEn = model.refInformProduct?.refHaz?.tradeNameEn || null;
                            },
                            disabled: viewOnly,
                            list: () => [{ id: model.id, name: "" }]
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field, model } })
                    );
                }
            }),
            ...createFieldInformProduct({ props, data, key: `${prefix}refInformProduct`, items, initItems, isLoading }),
            {
                visible: () =>
                    conditionFormChecker({ props, data, executeKey: "visibleField", params: { componentKey: "InformProductQtyList", model } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            viewOnlyInspection: viewOnlyInspection,
                            dataProp: data,
                            itemsKey: `${prefix}productQties`,
                            fetchCriteria: data.productQty?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            visiblePagination: true,
                            request,
                            inform: modelInform,
                            initInform: initModelInform,
                            informProduct: model,
                            initInformProduct: initModel,
                            informProducts: items,
                            initInformProducts: initItems,
                            hazLicense: model.refHazLicense,
                            storageLocations: model.refHazLicense?.hazLicenseStorageLocations?.map(d => d.refStorageLocation) || [],
                            showStorageLocation: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "InformProductQtyList", model } })
                    );
                    return (
                        <>
                            <Divider class="text-bold text-16" orientation="left">{i18n.global.t("views.request.informProductQty.title")}</Divider>
                            <InformProductQtyList {...componentProp}></InformProductQtyList>
                        </>
                    );
                }
            }
        ]
    });
};

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    let items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    let initItems = itemsKey ? lodash.get(initialModel, itemsKey) : initialModel;
    fetchData({ props, data }).then(page => {
        const fetchItems = page.data;
        items?.push(...lodash.cloneDeep(fetchItems));
        initItems?.push(...lodash.cloneDeep(fetchItems));
        /*
        fetchItems.forEach(item => {
            lodash.set(data, `productQty.${item.id}.fetchCriteria`, {
                select: ["**"],
                page: 0,
                size: 1000000,
                where: [{ name: "refHcProduct.id", type: "UUID", operator: "=", value: item.id }],
                sort: [{ name: "createDate", type: "ASC" }]
            });
        });
        */
    });
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria })
        .then(page => {
            setProduct({ products: page.data });
            return page;
        })
        .finally(() => setIsLoading(false));
};
